/**
 * Returns gender from value. Returns only male or female
 */
const getGenderValue = (value: string): Gender => {
  if (value === 'male') {
    return 'male'
  }

  return 'female'
}


export default getGenderValue
